import { __rest } from "tslib";
import React from 'react';
import SpinnerIcon from '../../assets/svgs/Spinner.svg';
import clsx from 'clsx';
import './Spinner.less';
const VARIANT_CLASSES = {
    default: 'kal-spinner--default',
    large: 'kal-spinner--large',
};
export default function Spinner(_a) {
    var { className, variant = 'default' } = _a, otherProps = __rest(_a, ["className", "variant"]);
    return (React.createElement(SpinnerIcon, Object.assign({ className: clsx(className, VARIANT_CLASSES[variant], 'kal-spinner'), changeHue: false }, otherProps)));
}
//# sourceMappingURL=Spinner.js.map